import { render, staticRenderFns } from "./AccessIndex.vue?vue&type=template&id=1e0a8f3c&"
import script from "./AccessIndex.vue?vue&type=script&lang=js&"
export * from "./AccessIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports